import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    // Optional normalized change callback. When provided, component will emit
    // normalized values based on input type (e.g., number -> number | undefined).
    onValueChange?: (value: unknown) => void;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, onChange, onValueChange, value, ...props }, ref) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (onValueChange) {
                if (type === 'number') {
                    const raw = e.target.value;
                    if (raw === '') {
                        onValueChange(undefined);
                        return;
                    }
                    const numeric = Number(raw);
                    onValueChange(Number.isFinite(numeric) ? numeric : undefined);
                    return;
                }
                onValueChange(e.target.value);
            }
            onChange?.(e);
        };

        const resolvedValue = (() => {
            if (type === 'number') {
                return (value as any) ?? '';
            }
            return value as any;
        })();

        return (
            <input
                type={type}
                className={cn(
                    'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
                    className
                )}
                ref={ref}
                value={resolvedValue}
                onChange={handleChange}
                {...props}
            />
        );
    }
);
Input.displayName = 'Input';

export { Input };
